import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
import Reports from "../views/Reports.vue";
import AppointmentForm from "../components/AppointmentForm.vue";
import Patients from "../views/Patients.vue";
import Appointments from "../views/Appointments.vue";
import Scheduling from "../views/Scheduling.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Scheduling",
    component: Scheduling,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/reports",
    name: "Reports",
    component: Reports,
  },
  {
    path: "/appointments",
    name: "Appointments",
    component: AppointmentForm,
  },
  {
    path: "/all_appointments",
    name: "Appointments",
    component: Appointments,
  },
  {
    path: "/appointments/:id",
    name: "Appointments",
    component: AppointmentForm,
  },
  {
    path: "/patients",
    name: "Patients",
    component: Patients,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
